// src/lib/room-cover.ts: the cover a room shows before it has an image of its own. A tenant room (or a suggested
// room the form adds, such as an in-law suite) may name `cover`, an idea whose approved image stands in, so no
// room tile, sidebar thumbnail or rooms-table row is ever a blank square (round-1 QA).
import type { PublicTenant } from "../../shared/tenant";

/** The small image of the room's configured cover idea, or null (no cover set, or its image is not live). */
export function roomCover(t: Pick<PublicTenant, "rooms" | "roomSuggestions" | "ideas"> | null | undefined, roomKey: string | null | undefined): string | null {
  if (!t || !roomKey) return null;
  const def = t.rooms.find((r) => r.id === roomKey) ?? t.roomSuggestions.find((r) => r.id === roomKey);
  if (!def?.cover) return null;
  const img = t.ideas.find((i) => i.id === def.cover)?.image;
  return img ? img.srcSmall || img.src : null;
}
